import React, { useState,useRef } from 'react'
import {localestr} from '../utils.js'
import icon from '../icons.svg'
import './Checker.css'


function CheckerNotMove({caption,data,setData}){
    const [curr, setCurr] = useState(0)
    const targetRef = useRef()

    function changeHandler(e,idx){
        const newData=[...data]
        newData[idx].checked=!newData[idx].checked
        setData(newData)
    }
    function check(direction=true){
        let newData=data.map(el=>{return {...el,checked:direction}})

        setData(newData)
    }
    function keyClick(e){
        if(e.key==='ArrowUp') {if(curr>0) setCurr(curr-1)}
        else if(e.key==='ArrowDown') {if(curr<data.length-1) setCurr(curr+1)}
        else if(e.key==='Home') setCurr(0)
        else if(e.key==='End') setCurr(data.length-1)
        //else if(e.key==='Space') changeHandler(e,curr)
    }
    function setFocus(el){
        if (!el) return
        if(document.activeElement.localName==='body') el.focus()
        //el.focus()
    }

    const items=data.map((el,idx)=>{
        if(idx===curr) return(
            <div className='ch_item selected' key={idx}><label><input ref={e=>{setFocus(e);return targetRef}} type='checkbox' checked={el.checked} onChange={e=>changeHandler(e,idx)}/>{el.name}</label></div>)
        else return(
            <div className='ch_item' key={idx}><label><input type='checkbox' checked={el.checked} onChange={e=>changeHandler(e,idx)}/>{el.name}</label></div>)
    })

    return(
        <fieldset className='legend'><legend>{caption}</legend>
            <div className='toolBar'>
                <div  tabIndex='0' className='toolBarItem' title={localestr('Відмітити')+' (Ins)'} 
                    onClick={()=>check()}
                    onKeyUp={(e)=>{if(e.key === 'Enter') check()}}><img src={icon+'#checkBut'} alt={localestr('Відмітити')} /></div>
                <div  tabIndex='0' className='toolBarItem' title={localestr('Зняти відмітки')+' (Ins)'} 
                    onClick={()=>check(false)}
                    onKeyUp={(e)=>{if(e.key === 'Enter') check(false)}}><img src={icon+'#unchckBut'} alt={localestr('Зняти відмітки')} /></div>
            </div>
            <div onKeyUp={keyClick}>{items}</div>
        </fieldset>
    )

}


export default CheckerNotMove